import { Badge as MantineBadge } from "@mantine/core"

export const Badge = MantineBadge.extend({
  styles: {
    root: {
      fontWeight: 500,
      fontSize: "0.75rem",
      textTransform: "none",
    },
  },
})
